export const getNoAudioSourceInfoText = (
  sourceName: string | undefined,
  hasPrefix?: boolean,
) => {
  return `${hasPrefix ? 'audio' : 'Audio'} playback is unavailable for ${
    sourceName ?? 'this source'
  }`;
};
